import { useNavigate } from "react-router-dom";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CrossIcon } from "../../icons/Icon";
import { CloseIcon } from "../../icons/Icon2";
import Button from "../Dealers/Button";

const SelectWarehouse = ({ mode, handleCloseModal, orderId, shippingInfo }) => {
  const navigate = useNavigate();
  const filteredShippingInfo = shippingInfo.filter(
    (s) =>
      s.dispatchStatus === "Completed" || s.dispatchStatus === "Dispatched",
  );

  const goToDispatchDetails = (w) => {
    navigate("/dispatch/details/" + orderId + "/" + w);
    handleCloseModal();
  };

  return (
    <div
      className={styles.order_modal}
      style={{ backgroundColor: mode && "#232529" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Select Warehouse </p>
        <div onClick={handleCloseModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <p
        className={styles.select_warehouse_text}
        style={{ color: mode && "#FFFFFF" }}
      >
        Order has multiple warehouse items. Choose Warehouse to view Dispatch
        Details!
      </p>

      <div className={styles.warehouse_tab_con}>
        {filteredShippingInfo.map((s) => (
          <button
            className={styles.warehouse_tab}
            key={s.warehousename}
            onClick={() => goToDispatchDetails(s.warehouseId)}
            style={{
              color: mode && "#9C9797",
              backgroundColor: mode && "#2C2E33",
              boxShadow: mode && "none",
            }}
          >
            {s.warehousename}
          </button>
        ))}
      </div>

      <div>
        <Button
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonText={"Close"}
          buttonIcon={<CrossIcon color={"#FFFFFF"} />}
          buttonClick={handleCloseModal}
        />
      </div>
    </div>
  );
};

export default SelectWarehouse;
